import type { ComponentType } from "react";
import React, { memo, useMemo } from "react";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import { Link } from "react-router-dom";
import PostcardCampaignLocationBase from "./activeLocations/PostcardCampaignLocation";
import { BRAND_CONST, LocSubsStatus } from "@/config/constants";
import RpVirtualList from "@/components/virtual/RpVirtualList";

const InActivePostCardCampaignLocations = ({
  fallOutSideLocations = [],
  unSubscribedLocations = [],
  selectedBrand,
  values,
  campaign,
  setExpanded,
  expanded,
  setFieldValue,
  setFieldError,
}: any) => {
  const PostcardCampaignLocation =
    PostcardCampaignLocationBase as ComponentType<any>;
  const isThereNoInactiveLocations = useMemo(() => {
    return [...fallOutSideLocations, ...unSubscribedLocations].length === 0;
  }, [fallOutSideLocations, unSubscribedLocations]);

  const inactiveLocations = useMemo(() => {
    return [
      ...fallOutSideLocations.map((loc) => ({
        ...loc,
        subscriptionStatusType: LocSubsStatus.FALLOUT,
      })),
      ...unSubscribedLocations.map((loc) => ({
        ...loc,
        subscriptionStatusType: LocSubsStatus.UNSUBSCRIBED,
      })),
    ];
  }, [fallOutSideLocations, unSubscribedLocations]);

  const renderInactiveLocations = () => {
    return (
      <RpVirtualList
        items={inactiveLocations}
        computeItemKey={(index) => {
          const loc = inactiveLocations[index];
          return `${loc.subscriptionStatusType}-${loc.id || index}`;
        }}
        renderItem={(loc) => {
          const locName = `${loc.location_name}`?.concat(`, ${loc.state}`);

          return (
            <PostcardCampaignLocation
              subscriptionStatusType={loc.subscriptionStatusType}
              name={locName}
              is30DaysLeftToJoinCampaign={loc.is30DaysLeftToJoinCampaign}
              key={loc.id}
              loc={loc}
              locFormData={values[loc.id]}
              campaign={campaign}
              setExpanded={setExpanded}
              expanded={expanded}
              setFieldValue={setFieldValue}
              setFieldError={setFieldError}
              isUnsubscribed={true}
            />
          );
        }}
      />
    );
  };

  if (isThereNoInactiveLocations) {
    return (
      <>
        <div className="my-5 text-center">
          <Alert severity="info">
            <strong>There is no inactive location.</strong>
          </Alert>
        </div>
      </>
    );
  }

  return (
    <div className="un-subscribed-locations my-5">
      {!isThereNoInactiveLocations &&
        selectedBrand?.id === BRAND_CONST.JINYA_RAMEN_BAR_BRAND_ID && (
          <div className="mb-1 d-flex justify-content-end">
            <Button
              component={Link}
              to="/self-subscribe/jinya-ramen-bar"
              color="primary"
              className="text-case-initial"
              // variant="outlined"
              // startIcon={<Icon>info</Icon>}
            >
              <u>Click here to subscribe your location(s)</u>
            </Button>
          </div>
        )}

      {renderInactiveLocations()}
    </div>
  );
};
export default memo(InActivePostCardCampaignLocations);
